import { parseToHsl, getContrast, lighten, darken } from 'polished';
import { CalculateColorSet, CalculateGraysColorSet, IsDark } from './types';

export const calculateColorSet: CalculateColorSet = baseColor => {
    const C10 = baseColor;
    const C20 = isDark(baseColor)
        ? progressiveLighten(0.1, baseColor)
        : progressiveDarken(0.08, baseColor);
    const C30 = isDark(baseColor)
        ? progressiveLighten(0.17, baseColor)
        : progressiveDarken(0.14, baseColor);
    const grays = calculateGraysColorSet(baseColor);

    const colorSet = { C10, C20, C30, ...grays };

    return colorSet;
};

const isDark: IsDark = color => {
    const REFERENCE_WHITE = '#FFFFFF';
    const REFERENCE_BLACK = '#272727';

    const isBetterVisibleOnWhite =
        getContrast(REFERENCE_WHITE, color) > getContrast(REFERENCE_BLACK, color);

    return isBetterVisibleOnWhite;
};

const progressiveLighten = (maxAmount: number, baseColor: string) => {
    const baseHsl = parseToHsl(baseColor);
    return lighten(maxAmount - baseHsl.lightness / 100, baseColor);
};

const progressiveDarken = (maxAmount: number, baseColor: string) => {
    const baseHsl = parseToHsl(baseColor);
    return darken(maxAmount * baseHsl.lightness, baseColor);
};

const calculateGraysColorSet: CalculateGraysColorSet = baseColor => {
    const GRAYS_FOR_LIGHT_BACKGROUND = {
        G10: '#272727',
        G20: '#767676',
        G30: '#DEDEDE',
        G40: '#F4F4F4',
        G50: '#FFFFFF',
    };
    const GRAYS_FOR_DARK_BACKGROUND = {
        G10: '#FFFFFF',
        G20: '#F4F4F4',
        G30: '#DEDEDE',
        G40: '#767676',
        G50: '#272727',
    };

    const graysColorSet = isDark(baseColor)
        ? GRAYS_FOR_DARK_BACKGROUND
        : GRAYS_FOR_LIGHT_BACKGROUND;

    return graysColorSet;
};
